import {addToCartHandler} from "./addToCart";

export const adpObserver = new MutationObserver((mutations) => {
    mutations.map((mutation) => {
        const container = mutation.target.querySelector('.adp-vol-wrapper');

        if(container && mutation.addedNodes.length > 0) {
            const rows = [...container.querySelectorAll('tbody tr')];

            container.querySelector('thead tr').appendChild(document.createElement('th'));

            rows.map(row => {
                const quantity = +row.firstElementChild.innerText;

                const td = document.createElement('td');
                const button = document.createElement('button');
                button.type = 'button';
                button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="19" height="20" viewBox="0 0 19 20"><path stroke="#0C1D15" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 19c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm11 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm0-4H3V1H1"/><path fill="#0C1D15" d="m3 3 6.005.429Zm13.143 7.002L16 11H3m9-7h6Zm3-3v6Z"/><path stroke="#0C1D15" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m3 3 6.005.429m7.138 6.573L16 11H3m9-7h6m-3-3v6"/></svg>';
                button.addEventListener('click', () => {
                    addToCartHandler({preventDefault: () => {}, currentTarget: mutation.target}, quantity);
                });

                td.appendChild(button);
                row.appendChild(td);
            });

            setTimeout(() => {
                adpObserver.disconnect();
            }, 250);
        }
    });
});

